import NoSleep from 'nosleep.js'

let nativeLock: WakeLockSentinel | null = null
let noSleep: NoSleep | null = null

type WakeLockType = 'screen'
interface WakeLockSentinel {
  released: boolean
  type: WakeLockType
  release(): Promise<void>
  addEventListener(type: 'release', listener: () => void): void
}

function hasNative(): boolean {
  return typeof navigator !== 'undefined' && 'wakeLock' in navigator
}

export async function acquireWakeLock(): Promise<void> {
  if (hasNative()) {
    try {
      nativeLock = await (navigator as any).wakeLock.request('screen')
      nativeLock?.addEventListener('release', () => {
        nativeLock = null
      })
      return
    } catch {
      
    }
  }
  if (!noSleep) noSleep = new NoSleep()
  try {
    await noSleep.enable()
  } catch {
    
  }
}

export function releaseWakeLock(): void {
  if (nativeLock && !nativeLock.released) {
    nativeLock.release().catch(() => undefined)
    nativeLock = null
  }
  if (noSleep) {
    noSleep.disable()
  }
}

export function attachWakeLockListeners(): () => void {
  const onVisibility = () => {
    if (document.visibilityState === 'visible') {
      void acquireWakeLock()
    }
  }
  document.addEventListener('visibilitychange', onVisibility)
  return () => document.removeEventListener('visibilitychange', onVisibility)
}
